import ActionsPopover from "@/components/ActionsPopOver/ActionsPopOver";
import ActionsPopOverItem from "@/components/ActionsPopOver/ActionsPopOverItem";
import FileDownloader from "@/components/FileDownloader/FileDownloader";
import { exportBusinessTravel } from "@/pages/employee/business_travel/useBusinessTravel";
import { ReactNode, useState } from "react";

export default function ExportBusinessTravelAction({
  year,
  children,
}: {
  year?: number;
  children: ReactNode;
}) {
  const [open, setOpen] = useState<boolean>(false);

  const onSuccess = () => {
    setOpen(false);
  };

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };
  return (
    <ActionsPopover
      open={open}
      onOpenChange={handleOpenChange}
      actions={
        <>
          <FileDownloader
            fileOutputName={`export-business-travel.xlsx`}
            fileUrlFn={() => exportBusinessTravel({})}
            onFinish={onSuccess}
            customRender={(props) => (
              <ActionsPopOverItem
                {...props}
                black
              >
                Export all
              </ActionsPopOverItem>
            )}
            addTimestampAndCompany={true}
          />
          <FileDownloader
            fileOutputName={`export-business_travel-${year}.xlsx`}
            fileUrlFn={() => exportBusinessTravel({ year })}
            onFinish={onSuccess}
            customRender={(props) => (
              <ActionsPopOverItem
                {...props}
                black
              >
                Export {year}
              </ActionsPopOverItem>
            )}
            addTimestampAndCompany={true}
          />
        </>
      }
    >
      {children}
    </ActionsPopover>
  );
}
